import { useState } from "react";
import { api } from "@/lib/api";

export default function ReturningGuest({ onConfirmed, onError }) {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const canSubmit =
    code.trim().length > 0 &&
    name.trim().length > 0 &&
    email.trim().length > 0 &&
    !loading;

  const submit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setLoading(true);
    try {
      await api.post("/access-code/verify", {
        code: code.trim().toLowerCase(),
        full_name: name.trim(),
        email: email.trim(),
      });
      setCode("");
      setName("");
      setEmail("");
      onConfirmed?.();
    } catch (err) {
      const msg = err?.response?.data?.detail || "Code not recognised.";
      onError?.(typeof msg === "string" ? msg : "Code not recognised.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="returning-guest-form" className="space-y-8">
      <div className="fade-up" style={{ animationDelay: "60ms" }}>
        <label className="block small-caps mb-3" style={{ color: "#B9929D" }} htmlFor="rg-code">
          Returning-guest code
        </label>
        <input
          id="rg-code"
          data-testid="field-code"
          className="kynn-input"
          placeholder=""
          value={code}
          onChange={(e) => setCode(e.target.value)}
          autoCapitalize="off"
          autoCorrect="off"
          required
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="fade-up" style={{ animationDelay: "120ms" }}>
          <label className="block small-caps mb-3" style={{ color: "#B9929D" }} htmlFor="rg-name">
            Your name
          </label>
          <input
            id="rg-name"
            data-testid="field-rg-name"
            className="kynn-input"
            placeholder=""
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="fade-up" style={{ animationDelay: "160ms" }}>
          <label className="block small-caps mb-3" style={{ color: "#B9929D" }} htmlFor="rg-email">
            Email
          </label>
          <input
            id="rg-email"
            data-testid="field-rg-email"
            type="email"
            className="kynn-input"
            placeholder=""
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
      </div>

      <div className="pt-4 flex items-center gap-6 flex-wrap">
        <button
          type="submit"
          disabled={!canSubmit}
          data-testid="verify-code-btn"
          className="btn-primary"
        >
          {loading ? "Verifying…" : "Confirm my spot"} →
        </button>
        <span className="text-xs italic" style={{ color: "#b8c975", lineHeight: 1.5 }}>
          This is instant confirmation. Please add to your calendar!
        </span>
      </div>
    </form>
  );
}
